import { avantSolarApi } from "api/authApi";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";

const ChangePassWordModal = ({ modal, toggleModal, idUser }) => {
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(null);
  const { jwt } = useSelector((state) => state.auth);

  const [datos, setDatos] = useState();

  useEffect(() => {
    setDatos({
      password: "",
      repeat_password: "",
      id_cliente: idUser,
    });
  }, [idUser]);

  const cerrarModal = () => {
    toggleModal();
    setError(null);
  };

  const closeBtn = (
    <button className="close" onClick={cerrarModal} type="button">
      &times;
    </button>
  );

  const handleChangeInput = (event) => {
    setDatos({ ...datos, [event.target.name]: event.target.value });
  };

  const putPassword = async () => {
    setError(null);
    try {
      const response = await avantSolarApi.put(`/changePassword`, datos, {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + jwt,
        },
      });

      let data = response.data.data;

      if (data?.code == 200) {
        setSuccess(true);
      } else {
        setError(data.message);
      }
    } catch (error) {
      setError(error.response.data.message);
    }
  };

  const cambiarPassword = () => {
    setError(null);
    const { password, repeat_password } = datos;

    if (password.trim() == "" || repeat_password.trim() == "") {
      setError("No puedes dejar las contraseñas en blanco");
    } else {
      if (password == repeat_password) {
        putPassword();
      } else {
        setError("Las contraseñas no coinciden");
      }
    }
  };
  return (
    <>
      <Modal isOpen={modal} toggle={toggleModal}>
        <ModalHeader close={closeBtn} toggle={toggleModal}>
          Cambiar Contraseña
        </ModalHeader>
        <ModalBody>
          <span className="h6 text-center w-100 bg-primary mb-4">
            <p>
              Usuario: <span className="font-weight-bold">{idUser}</span>
            </p>
          </span>
          <div className="mt-3 d-flex justify-content-center">
            <div className="w-75">
              <label className="d-flex  flex-column justify-content-start text-start">
                <p className="text-start">Nueva Contraseña:</p>{" "}
                <input
                  name="password"
                  onChange={handleChangeInput}
                  className="rounded p-1"
                  type="password"
                />
              </label>
              <label className="d-flex mt-2 flex-column justify-content-start text-start">
                <p className="text-start">Repita Contraseña:</p>{" "}
                <input
                  name="repeat_password"
                  onChange={handleChangeInput}
                  className="rounded p-1"
                  type="password"
                />
              </label>{" "}
              {success && (
                <div
                  className="alert alert-success mt-3 text-center"
                  role="alert"
                >
                  La contraseña cambiada correctamente
                </div>
              )}
              {error && (
                <div
                  className="alert alert-danger mt-3 text-center"
                  role="alert"
                >
                  {error}
                </div>
              )}
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={cambiarPassword}>
            Cambiar Contraseña
          </Button>
          <Button color="danger" onClick={cerrarModal}>
            Cerrar
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default ChangePassWordModal;
